import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useTranslation } from 'react-i18next';

const Loader = () => {
  const { t } = useTranslation();

  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <ProgressSpinner
          strokeWidth="8"
          animationDuration=".8s"
        />
        <div className="loading-text"> {`${t('common.loading')}`} </div>
      </div>
    </div>
  );
};

export default Loader; 